import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpDeleteProPhotosServiceOptions,
	httpDeleteProPhotosService
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useDeleteServiceProPhotosImages = (
	urlParams: Omit<HttpDeleteProPhotosServiceOptions, 'imageIds'>,
	options?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			{ imageIds: HttpDeleteProPhotosServiceOptions['imageIds'] }
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: ({ imageIds }) =>
			httpDeleteProPhotosService({ ...urlParams, imageIds }),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: async (data, variables, onMutateResult, context) => {
			await queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, urlParams.serviceId]
			})
			await queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_GALLERY_IMAGES_PRO_PHOTOS]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
